/* eslint-disable no-mixed-spaces-and-tabs */
import { GEOFENCE_MANAGEMENT_LIST, GEOFENCE_MANAGEMENT_LIST_SUCCESS, GEOFENCE_MANAGEMENT_LIST_ERROR } from './constants';
import { GEOFENCE_MANAGEMENT_DETAILS, GEOFENCE_MANAGEMENT_DETAILS_SUCCESS, GEOFENCE_MANAGEMENT_DETAILS_ERROR } from './constants';
import { ADD_GEOFENCE_MANAGEMENT_DETAILS, ADD_GEOFENCE_MANAGEMENT_DETAILS_SUCCESS, ADD_GEOFENCE_MANAGEMENT_DETAILS_ERROR } from './constants';
import { UPDATE_GEOFENCE_MANAGEMENT, UPDATE_GEOFENCE_MANAGEMENT_SUCCESS, UPDATE_GEOFENCE_MANAGEMENT_ERROR } from './constants';
import { DELETE_GEOFENCE_MANAGEMENT, DELETE_GEOFENCE_MANAGEMENT_SUCCESS, DELETE_GEOFENCE_MANAGEMENT_ERROR } from './constants';
import { datetimeCovertertolocal } from '../../datetime-converter';
export default function geofencemanagementReducer(state, action) {
	let geofencemanagement = [];
	

	switch (action.type) {
	case GEOFENCE_MANAGEMENT_LIST:
		return { ...state, pending: true };
	  
	case GEOFENCE_MANAGEMENT_LIST_SUCCESS:

		
		if (action.payload && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};
				const start = datetimeCovertertolocal(item.startTime ?item.startTime: '<Not Set>');
				const newstart = item.endTime ? ( start.localtime) : '<Not Set>';
				const end = datetimeCovertertolocal(item.endTime ?item.endTime: '<Not Set>');
				const newenddate = item.endTime ? ( end.localtime) : '<Not Set>';

				data.id = item.id ? item.id : 0;
				data.name = item.name ?  item.name : '';
				data.pipelineId = item.pipelineId ? item.pipelineId : 0;
				data.limit = item.limit ? item.limit : ' ';
				data.notification = item.notification === true ? 'true' : 'false' ;
				data.booleannotification = item.notification;
				data.endTime = newenddate;
				data.startTime = newstart;
				data.utcstart = item.startTime;
				data.utcend = item.endTime;
				data.averageSpeed = item.averageSpeed;
				return geofencemanagement.push(data);

			});

			// eslint-disable-next-line no-mixed-spaces-and-tabs

			return { ...state, geofencemanagement : geofencemanagement, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, geofencemanagement : geofencemanagement, pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
	  
	case GEOFENCE_MANAGEMENT_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case GEOFENCE_MANAGEMENT_DETAILS:
		return { ...state, pending: true };

	case GEOFENCE_MANAGEMENT_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case GEOFENCE_MANAGEMENT_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_GEOFENCE_MANAGEMENT_DETAILS:
		return { ...state, pending: false };

	case ADD_GEOFENCE_MANAGEMENT_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_GEOFENCE_MANAGEMENT_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_GEOFENCE_MANAGEMENT:
		return { ...state, pending: false };

	case UPDATE_GEOFENCE_MANAGEMENT_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_GEOFENCE_MANAGEMENT_ERROR:
		return { ...state, pending: false, error: true };
	  // eslint-disable-next-line no-mixed-spaces-and-tabs
	  
	case DELETE_GEOFENCE_MANAGEMENT:
		return { ...state, pending: false };

	case DELETE_GEOFENCE_MANAGEMENT_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_GEOFENCE_MANAGEMENT_ERROR:
		return { ...state, pending: false, error: true };

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}